import { useState } from 'react';

interface IForceRefresh {
  refresh: () => void;
  isVisible: boolean;
}

export function useForceRefresh(): IForceRefresh {
  const [visible, setVisible] = useState(true);
  const forceRefresh = () => {
    setVisible(false);
    setTimeout(() => setVisible(true), 10);
  };

  return {
    refresh: forceRefresh,
    isVisible: visible,
  };
}
